import { useState, type ReactNode } from 'react'
import { Moon, Sun } from 'lucide-react'
import { Button } from '@/components/ui/button'

function ThemeToggle() {
  const [dark, setDark] = useState(() => document.documentElement.dataset.theme === 'dark')
  const toggle = () => {
    const next = !dark
    document.documentElement.dataset.theme = next ? 'dark' : 'light'
    try {
      localStorage.setItem('panel.theme', next ? 'dark' : 'light')
    } catch {
      /* storage unavailable; theme still applies for this visit */
    }
    setDark(next)
  }
  const label = `Switch to ${dark ? 'light' : 'dark'} theme`
  return (
    <Button variant="ghost" size="icon" onClick={toggle} title={label} aria-label={label}>
      {dark ? <Sun aria-hidden="true" /> : <Moon aria-hidden="true" />}
    </Button>
  )
}

/** Full-page frame for standalone status pages: top bar, faint dot grid, centered card. */
export function StatusPageShell({ children }: { children: ReactNode }) {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-bg">
      <header className="flex h-14 shrink-0 items-center justify-between border-b border-border bg-surface px-4 sm:px-6">
        <div className="flex items-center gap-2">
          <div className="flex size-6 items-center justify-center rounded-sm bg-primary font-semibold text-primary-on">OP</div>
          <span className="font-semibold text-text">Challan Fulfilment</span>
        </div>
        <ThemeToggle />
      </header>

      <main className="relative flex flex-1 items-center justify-center px-4 py-8">
        {/* Flat dot grid, decorative only. */}
        <svg aria-hidden="true" className="pointer-events-none absolute inset-0 size-full fill-border">
          <defs>
            <pattern id="status-dots" width="20" height="20" patternUnits="userSpaceOnUse">
              <rect width="2" height="2" x="9" y="9" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#status-dots)" />
        </svg>

        <div className="relative flex w-full max-w-[360px] flex-col gap-4 rounded-lg border border-border bg-surface p-6">{children}</div>
      </main>
    </div>
  )
}
